/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelAmendmentRequest
 */
export interface CancelAmendmentRequest {
    /**
     * 
     * @type {string}
     * @memberof CancelAmendmentRequest
     */
    adminComment?: string;
}

/**
 * Check if a given object implements the CancelAmendmentRequest interface.
 */
export function instanceOfCancelAmendmentRequest(value: object): value is CancelAmendmentRequest {
    return true;
}

export function CancelAmendmentRequestFromJSON(json: any): CancelAmendmentRequest {
    return CancelAmendmentRequestFromJSONTyped(json, false);
}

export function CancelAmendmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelAmendmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'adminComment': json['adminComment'] == null ? undefined : json['adminComment'],
    };
}

export function CancelAmendmentRequestToJSON(value?: CancelAmendmentRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'adminComment': value['adminComment'],
    };
}

